import { translate } from "@/domain/utils/translate";

/**
 * Librería de mensajes de errores de producto base
 */
const getBaseProductCodes = () => ({
  REQUIRED_ERROR : translate('massive_charge.errors.required'),
  NAME_MIN_LENGTH_ERROR : translate('massive_charge.errors.name_min_length'),
  NAME_MAX_LENGTH_ERROR : translate('massive_charge.errors.name_max_length'),
  BASE_PRODUCT_NAME_FORMAT : translate('massive_charge.errors.name_format'),
  BLANK_ERROR : translate('massive_charge.errors.blank'),
  BLANK_ERROR_AFTER : translate('massive_charge.errors.blank_after'),
  DESCRIPTION_MIN_LENGTH_ERROR : translate('massive_charge.errors.description_length'),
  DESCRIPTION_MAX_LENGTH_ERROR : translate('massive_charge.errors.description_length'),
  URL_ERROR : translate('massive_charge.errors.url'),
  DUPLICATE_VARIANTS_ERROR : translate('massive_charge.errors.duplicated_variants'),
  STATUS_VARIANTS_ERROR : translate('massive_charge.errors.status_variants'),
  DUPLICATE_MAIN_VARIANTS_VALUES_ERROR : translate('massive_charge.errors.duplicated_main'),
  VARIANTS_WITH_ERROR : translate('massive_charge.errors.variants'),
  SHIPPING_TYPES_REQUIRED : translate('massive_charge.errors.shipping_required'),
  TAGS_ERROR : translate('massive_charge.errors.existing_tag'),
  FORMAT_ERROR : translate('massive_charge.errors.format'),
  TAGS_FORMAT : translate('massive_charge.errors.tag_format'),
  MAIN_VARIANTS_KEYS_ERROR_1 : translate('massive_charge.errors.main_variants_key'),
  MAIN_VARIANTS_KEYS_ERROR_2 : translate('massive_charge.errors.main_variants_key_2'),
  DUPLICATE_SHIPPING_TYPES : translate('massive_charge.errors.duplicated_shipping'),
  MAX_TAGS_ERROR : translate('massive_charge.errors.max_tags'),
});

export default getBaseProductCodes;
